// extracted by mini-css-extract-plugin
export default {"RemoveDeliveryTypeCell":"RemoveDeliveryTypeCell_RemoveDeliveryTypeCell__9ODpa","button":"RemoveDeliveryTypeCell_button__X5wSL"};